import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { useParams } from 'react-router-dom';
import { useGetArticleDetailsQuery } from '@/redux/articles';
import { ArticleOverviewDetailsPanel } from '@/views';

const useId = () => {
  const params = useParams<'id'>();
  return params.id!;
};

export function ArticleOverviewDetailsPage() {
  const { t } = useTranslation();
  const id = useId();

  const { data } = useGetArticleDetailsQuery({ id });
  const title = data?.title ?? t('fetchFallbackTitle');

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path href="/help">{t('articles.overview.title')}</Page.Path>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card title={title} icon={<Icon type="article" />} color="#814A93">
          <ArticleOverviewDetailsPanel id={id} />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
